export const USER_API_CONSTANTS = {
  USER_PERSONAL_INFO: "userAccount/getPersonalInfo",
};
